import { useEffect, useState } from "react";
import PointRewardList from "./PointRewardList";
import PointRewardSortHeader from "./PointRewardSortHeader";
import PointsRewardsHeader from "./PointsRewardsHeader";
import { pointRewardTableData } from "../../data/order/pointRewardTableData";
import { useMilesPoints } from "../../hooks/useMilesPoints";
import CommonPaginationSection from "../common/CommonPaginationSection";

function PointsRewardsSection() {
  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 10,
    total: 10,
  });
  const { getRewards } = useMilesPoints();
  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState([]);
  const [ogData, setOgData] = useState([]);
  const [filter, setFilter] = useState("");
  const [sort, setSort] = useState({
    orderBy: "createdAt",
    order: "asc",
  });

  const loadData = () => {
    getRewards({
      setLoading,
      page: pagination.page,
      limit: pagination.perPage,
      callback: (rewards, total) => {
        setOgData(rewards);
        setOrders(rewards.map((reward) => pointRewardTableData(reward)));
        setPagination((prev) => ({ ...prev, total }));
      },
      filter,
      sort,
    });
  };

  useEffect(() => {
    loadData();
  }, [filter, pagination.page, pagination.perPage, sort]);

  return (
    <div className="flex flex-col w-full">
      <div className="flex flex-col w-full">
        <PointsRewardsHeader
          value={filter}
          onFilterChange={(value) => setFilter(value)}
          callback={(reward) => {
            setOgData([reward, ...ogData]);
            setOrders([pointRewardTableData(reward), ...orders]);
          }}
        />
        <PointRewardSortHeader
          onSortChange={setSort}
          sortField={sort.orderBy}
          sortType={sort.order}
        />
        <PointRewardList
          loading={loading}
          ogData={ogData}
          orders={orders}
          callback={(reward) => {
            const updatedRewards = ogData.map((og) =>
              og._id === reward._id ? reward : og
            );
            setOgData(updatedRewards);
            setOrders(
              updatedRewards.map((reward) => pointRewardTableData(reward))
            );
          }}
          onDelete={(reward) => {
            const updatedRewards = ogData.filter((og) => og._id !== reward._id);
            setOgData(updatedRewards);
            setOrders(
              updatedRewards.map((reward) => pointRewardTableData(reward))
            );
          }}
        />
        <div className="w-full mt-2">
          <CommonPaginationSection
            perPage={pagination.perPage}
            total={pagination.total}
            page={pagination.page}
            callback={(pg, perPage) =>
              setPagination({ ...pagination, page: pg, perPage })
            }
          />
        </div>
      </div>
    </div>
  );
}

export default PointsRewardsSection;
